import styled from "@emotion/styled";

const StyledChannelItemEmpty = styled.div`
    width: 100px;
    height: 100px;
`;

/**
 * component that servers as an empty placeholder the same size
 * as the channel icon component, for layout reasons
 */
export function ChannelItemEmpty() {
    return <StyledChannelItemEmpty role={"presentation"} />;
}

export default ChannelItemEmpty;
